<div fxLayout="column" fxLayoutGap="15px" >
  <div fxLayout="row">
    Zmiana transakcji
  </div>

  <div  fxFlex="100">
    <app-dict-terminal-import-row label="Transakcja" [control]="terminalImportRowControl" [multiple]="false" [required]="true" [partnerId]="terminalsObject.partner?.uuid"></app-dict-terminal-import-row>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <span fxFlex></span>

    <button
      mat-raised-button (click)="sendForm()" color="primary"
      [class.spinner]="processingRequest" [disabled]="processingRequest || !enableSaveButton"
    >Zapisz</button>
    <button (click)="closeDialog($event)" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>


